import React from 'react';
import VerificationForm from './VerificationForm';
import styles from './VerificationSection.module.css';

/**
 * VerificationSection Component
 * Personal verification form - full page component
 */
const VerificationSection = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.sectionTitle}>Personal Verification</h3>
      <VerificationForm />
    </div>
  );
};

export default VerificationSection;
